module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image5b.679ae3c3.webp";